import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../src/store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../src/store/wishlists/index.ts'), 'wishlists/index.ts')
  resolveStoreModules(require('../src/store/trending-posts/index.ts'), 'trending-posts/index.ts')
  resolveStoreModules(require('../src/store/signed-policies/index.ts'), 'signed-policies/index.ts')
  resolveStoreModules(require('../src/store/shared-wishlists/index.ts'), 'shared-wishlists/index.ts')
  resolveStoreModules(require('../src/store/settings/index.ts'), 'settings/index.ts')
  resolveStoreModules(require('../src/store/search/index.ts'), 'search/index.ts')
  resolveStoreModules(require('../src/store/search-assistance/index.ts'), 'search-assistance/index.ts')
  resolveStoreModules(require('../src/store/retailer-products/index.ts'), 'retailer-products/index.ts')
  resolveStoreModules(require('../src/store/retailer-product-links/index.ts'), 'retailer-product-links/index.ts')
  resolveStoreModules(require('../src/store/recommendations/index.ts'), 'recommendations/index.ts')
  resolveStoreModules(require('../src/store/profiles/index.ts'), 'profiles/index.ts')
  resolveStoreModules(require('../src/store/products/index.ts'), 'products/index.ts')
  resolveStoreModules(require('../src/store/product-sets/index.ts'), 'product-sets/index.ts')
  resolveStoreModules(require('../src/store/product-details/index.ts'), 'product-details/index.ts')
  resolveStoreModules(require('../src/store/media-objects/index.ts'), 'media-objects/index.ts')
  resolveStoreModules(require('../src/store/ltks/index.ts'), 'ltks/index.ts')
  resolveStoreModules(require('../src/store/likes/index.ts'), 'likes/index.ts')
  resolveStoreModules(require('../src/store/gift-guides/index.ts'), 'gift-guides/index.ts')
  resolveStoreModules(require('../src/store/follower/index.ts'), 'follower/index.ts')
  resolveStoreModules(require('../src/store/follower-statistics/index.ts'), 'follower-statistics/index.ts')
  resolveStoreModules(require('../src/store/experiments/index.ts'), 'experiments/index.ts')
  resolveStoreModules(require('../src/store/creator-shop/index.ts'), 'creator-shop/index.ts')
  resolveStoreModules(require('../src/store/creator-shop-search/index.ts'), 'creator-shop-search/index.ts')
  resolveStoreModules(require('../src/store/creator-shop-posts/index.ts'), 'creator-shop-posts/index.ts')
  resolveStoreModules(require('../src/store/creator-products/index.ts'), 'creator-products/index.ts')
  resolveStoreModules(require('../src/store/consumer-search/index.ts'), 'consumer-search/index.ts')
  resolveStoreModules(require('../src/store/collections/index.ts'), 'collections/index.ts')
  resolveStoreModules(require('../src/store/checkout/index.ts'), 'checkout/index.ts')
  resolveStoreModules(require('../src/store/categories/index.ts'), 'categories/index.ts')
  resolveStoreModules(require('../src/store/carts/index.ts'), 'carts/index.ts')
  resolveStoreModules(require('../src/store/brands/index.ts'), 'brands/index.ts')
  resolveStoreModules(require('../src/store/amplitude/index.ts'), 'amplitude/index.ts')
  resolveStoreModules(require('../src/store/creator-products/types.ts'), 'creator-products/types.ts')
  resolveStoreModules(require('../src/store/creator-products/utils.ts'), 'creator-products/utils.ts')
  resolveStoreModules(require('../src/store/gift-guides/types.ts'), 'gift-guides/types.ts')
  resolveStoreModules(require('../src/store/product-details/types.ts'), 'product-details/types.ts')
  resolveStoreModules(require('../src/store/product-sets/types.ts'), 'product-sets/types.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
